import React from 'react';
import {inject, observer} from 'mobx-react';

import E8ToolBar from './E8ToolBar';
import E8ToolBarMore from './E8ToolBarMore';
import E8Logout from './E8Logout';

@inject('portalThemeStore')
@observer
class E8HeaderRight extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {portalThemeStore} = this.props;
        const {pluginReload} = portalThemeStore;
        if (pluginReload) {
            portalThemeStore.getPlugins();
        }
    }
    
    render() {
        const {portalThemeStore} = this.props;
        const {pluginIds = [], pluginInsertCount} = portalThemeStore;

        return (
            <div className="e8header-right-toolbar">
                {
                    pluginIds.map((item, index) => {
                        return <div key={index} id={item} className="e8header-toolbar-plugin"/>;
                    })
                }
                {pluginInsertCount > 0 ?  <div className="e8header-toolbar-splitter"/> : null}
                <E8ToolBar {...this.props} />
                <E8ToolBarMore {...this.props} />
                <E8Logout {...this.props} />
            </div>
        );
    }
}

export default E8HeaderRight;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8HeaderRight.js